<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="LISTADO DE EVALUACIONES" key="1">
          <g-master name="evaluaciones"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    @action="masterAction"
                    :actions="false"
          >
            <template slot="progresoSlot" slot-scope="{text, record}">
              <a-progress :percent="parseInt(record.porcentaje)" status="active"/>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '@/util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        pageTitle: 'Evaluaciones',
        visible: false,
        nombre: '',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'person_requisition_evaluator',
          tableSetup: {
            customSlots: ['progresoSlot'],
            actions: {
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'llenar_formulario',
                  text: 'Formulario',
                  props: {size: 'small', type: 'link', icon: 'form', style: 'color:purple;'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Requisición', dataIndex: 'req_id', sorter: true},
              {title: 'Cédula evaluado', dataIndex: 'id_person_evaluado', sorter: true},
              {title: 'Evaluado', dataIndex: 'evaluado', sorter: true},
              {title: 'Cargo aspirante', dataIndex: 'cargo', sorter: true},
              {title: 'Tipo evaluación', dataIndex: 'tipo_evaluacion', sorter: true},
              {
                title: 'Porcentaje calificación',
                dataIndex: 'porcentaje',
                sorter: true,
                scopedSlots: {customRender: 'progresoSlot', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_evaluator'},
            {name: 'id_form'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_evaluator: this.$store.state.userInfo.id_emp
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'llenar_formulario':
            this.diligenciarFormulario(action.record)
            break
        }
      },
      diligenciarFormulario (formulario) {
        let fnAbrirVentana = (idFormFillout) => {
          let routeData = this.$router.resolve({
            name: 'FormFillout',
            query: {fillOutId: idFormFillout}
          })
          window.open(routeData.href, '_blank')
        }
        this.httpClient.getInstance().post('person_requisition_evaluator/formulario', {
          id_form: formulario.id_form,
          id_person: formulario.id_person_evaluado
        }).then(response => {
          fnAbrirVentana(response.data.id_forms_fillout)
        })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible regisrar el formulario.')
          })
      }
    },
    props: ['id_person_reg'],
    mounted () {
      this.httpClient = new HttpUtil()
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/EvaluacionesRequisiciones.vue